import { create, IntlProvider } from '../internal/hs-intl';
import { defaultLanguage } from '../internal/legacyI18nInit';

export interface SingleI18nProviderOptions {
  language: string;
  excludeFallback?: boolean;
}

export type SingleI18nProvider = IntlProvider;

export default ({
  language,
  excludeFallback,
}: SingleI18nProviderOptions): SingleI18nProvider => {
  const I18nProvider = create();
  const localesToLoad = [language];
  if (!excludeFallback) {
    localesToLoad.push(defaultLanguage);
  }
  I18nProvider.setLocale(localesToLoad);

  return I18nProvider;
};
